// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pwuLl{flex:1;justify-content:start;align-items:center}.Ctu8g{width:100%;aspect-ratio:16/9}.Y8rBY{width:100%;aspect-ratio:16/9;display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `pwuLl`,
	"videoWrapper": `Ctu8g`,
	"loaderWrapper": `Y8rBY`
};
export default ___CSS_LOADER_EXPORT___;
